<template >
    <!-- Page Header -->
    <div class="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
        <h1 class="page-title fw-semibold fs-18 mb-0">{{propData?.current}}</h1>
        <div class="ms-md-1 ms-0">
            <nav>
                <ol class="breadcrumb mb-0">
                    <li v-for="(value, key) in propData.list" :key="key" class="breadcrumb-item" :class="key == propData.list.length - 1 ? 'active' : ''">
                        <span v-if="key === propData.list.length - 1">{{value}}</span>
                        <NuxtLink v-else :to="getBreadcrumbLink(value)" class="text-decoration-none text-primary">
                            {{value}}
                        </NuxtLink>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
    <!-- Page Header Close -->
</template>
<script>
import { usePath } from '@/composables/usePath'

export default {
  props: {
    propData: Object,
  },
  setup() {
    const { mapPath } = usePath()
    return { mapPath }
  },
  methods: {
    getBreadcrumbLink(value) {
      // Mapping des liens de navigation (sans préfixe /admin/, mapPath l'ajoutera)
      const linkMap = {
        'Accueil': '/dashboard',
        'Tableau de Bord': '/dashboard',
        'Administration': '/administration',
        'Académie': '/academy',
        'Planning': '/planning',
        'Paramètres': '/parametre',
        'Paramètre': '/parametre',
        'IAM': '/iam',
        'Infrastructure': '/infrastructure',
        'Maquettes': '/maquettes',
        'Comptabilité': '/comptabilite/factures',
        'Factures': '/comptabilite/factures',
        'Établir': '/comptabilite/etablir',
        'Modèles': '/comptabilite/modeles',
        'Notes': '/notes',
        'Utilisateurs': '/iam/users',
        'Staff': '/iam/staff',
        'Postes': '/iam/postes',
        'Affectation': '/iam/affectation',
        'Étudiants': '/academy/students',
        'Session': '/academy/session',
        'Classes': '/administration/classes',
        'Départements': '/administration/departements',
        'Directions': '/administration/directions',
        'Établissements': '/administration/etablissements',
        'Filières': '/administration/filieres',
        'Formations': '/administration/formations',
        'Parcours': '/administration/parcours',
        'Services': '/administration/services',
        'Processus': '/parametre/processus',
        'Utilisateur': '/parametre/utilisateur',
        'Calendrier': '/planning/calendar',
        'Type d\'activités': '/planning/type-activites',
        'Scolarité': '/scolarite',
        'Présences': '/scolarite/presences',
        'Délibération': '/deliberation',
        'Prédélibération': '/deliberation/predeliberation',
        'Rapports & Statistiques': '/reports/statistiques',
        'Statistiques enseignement': '/reports/enseignement',
        'Statistiques étudiants': '/reports/statistiques',
        'Détails': '#'
      }

      const path = linkMap[value]
      if (!path) return '#'
      
      // Utiliser mapPath pour ajouter le préfixe /admin/ de manière cohérente
      return this.mapPath(path)
    }
  },
};

</script>

<style>
.breadcrumb-item a:hover {
  color: var(--bs-primary) !important;
  text-decoration: underline !important;
}
</style>